module.exports = __webpack_public_path__ + "img/서브_주력.a4a65acb.svg";